import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import './Yhteistyossa.scss'

import laatumuutot from '../../images/yhteistyokumppanit/Hämeen-Laatumuutot-logo-XS.png'
import salonviolet from '../../images/yhteistyokumppanit/Salon-Violet-musta.jpg'
import charmia from '../../images/yhteistyokumppanit/Charmia-Logo.png'
import kaunista from '../../images/yhteistyokumppanit/Kaunista_pintaa_LOGO-uusi.jpg'
import pop from '../../images/yhteistyokumppanit/POP_Pankki_Lammi.png'
import wilcode from '../../images/yhteistyokumppanit/wilcode-logo-pink-360x360.png'
import heavyEvents from '../../images/yhteistyokumppanit/HE-logo-SMALL-light-background2.png'
import kuntokeidas from '../../images/yhteistyokumppanit/Kuntokeidas_logo.jpg'
import tuulensuunVirta from '../../images/yhteistyokumppanit/TSV_logo.jpg'
import novate from '../../images/yhteistyokumppanit/novatelogo.png'

import hpkLogo from '../../images/yhteistyokumppanit/hpk-logo.png'
import aahLogo from '../../images/yhteistyokumppanit/AAH-logo.png'

const Yhteistyossa = () => {
  const [logoElements, setLogoElements] = useState(undefined)
  const [sportElements, setSportElements] = useState(undefined)
  const list = [
    { img: pop, url: 'https://www.poppankki.fi/lammin-osuuspankki', alt: 'POP Pankki - Lammin Osuuspankki' },
    { img: kaunista, url: 'https://kaunistapintaa.fi/', alt: 'Kaunista pintaa - Maalaus ja tapetointi' },
    { img: laatumuutot, url: 'http://www.laatumuutot.fi/', alt: 'Hämeen Laatumuutot' },
    { img: charmia, url: 'https://www.charmia.fi/myymalat/charmia-hameenlinna/', alt: 'Charmia' },
    { img: salonviolet, url: 'https://www.salonviolet.fi/', alt: 'Salon Violet - Hair & Beauty' },
    { img: wilcode, url: 'https://wilcode.fi', alt: 'Wilcode' },
    { img: heavyEvents, url: 'https://heavyevents.fi/muut-palvelut/', alt: 'Heavy Events'},
    { img: kuntokeidas, url: 'https://kuntokeidashameenlinna.com/', alt: 'Kuntokeidas Hämeenlinna' },
    { img: tuulensuunVirta, url: 'https://www.tuulensuunvirta.fi/', alt: 'Tuulensuun virta' },
    { img: novate, url: 'https://novate.fi/', alt: 'Novate - Se siistimpi siivouspalvelu' },

  ]
  const sportList = [
    { img: hpkLogo, url: 'https://hpk.fi', alt: 'HPK' },
    { img: aahLogo, url: 'https://www.aah-hml.fi/', alt: 'AAH Hämeenlinna' },
  ]

  useEffect(() => {
    window.scrollTo(0, 0)

    const elements = list.map((el) => (
      <div className='yhteistyoLogo'>
        <a href={el.url} target='_blank' rel='noopener noreferrer'>
          <img src={el.img} alt={el.alt} />
        </a>
      </div>
    ))
    setLogoElements(elements)

    const sportElements = sportList.map((el) => (
      <div className='yhteistyoLogo'>
        <a href={el.url} target='_blank' rel='noopener noreferrer'>
          <img src={el.img} alt={el.alt} />
        </a>
      </div>
    ))
    setSportElements(sportElements)
    // eslint-disable-next-line
  }, [])

  return (
    <div className='Yhteistyossa animate__animated animate__fadeIn'>
      <Helmet>
        <title>Laatu LKV | Yhteistyössä | Kiinteistönvälitys Hämeenlinna. Kiinteä ja edullinen välityspalkkio. Hyvä ja kokenut kiinteistönvälittäjä. Asunnon myynti kodistasi välittäen.</title>
      </Helmet>

      <h1
        className='customSubTitle'
        style={{ backgroundColor: '#fecbb8', padding: '16px 16px 12px 12px' }}>
        Yhteistyössä
      </h1>
      <p>
        Olemme verkostoituneet usean paikallisen pienyrittäjän kanssa tarjotaksemme asiakkaillemme
        etuhintaisia palveluilta asunnon ja paikkakunnan vaihtoon liittyviin palveluihin.
      </p>
      <div className='yhteistyossaLogoContainer'>{logoElements ? logoElements : null}</div>
      <p>Olemme mukana tukemassa myös paikallista urheilutoimintaa.</p>
      <div className='yhteistyossaLogoContainer'>{sportElements ? sportElements : null}</div>
    </div>
  )
}

export default Yhteistyossa
